<template>
  <v-dialog :value="dialog" :width="maxWidth">
    <v-card class="px-4 py-2" v-if="target">
      <div class="body-2 pb-2">
        状況報告{{ target.id === 0 ? "登録" : "編集" }}
      </div>
      <div class="d-flex">
        <v-text-field
          class="flex-grow-1 mr-2"
          style="font-size: 14px"
          label="入力者"
          v-model="target.user"
        ></v-text-field>
        <v-card
          height="52"
          outlined
          class="flex-grow-1 ml-2"
          style="border-color: #757575; max-width: 200px"
        >
          <div class="caption pl-2 pt-1">日時</div>
          <datetime
            v-model="target.date"
            input-class="chronology-datetime-picker"
            type="datetime"
            :max-datetime="currentDate"
          >
            <template slot="button-confirm" slot-scope="scope">
              <span v-if="scope.step === 'date'">
                <v-btn text color="indigo">時刻選択</v-btn>
              </span>
              <span v-if="scope.step === 'time'">
                <v-btn text color="indigo">OK</v-btn>
              </span>
            </template>
          </datetime>
        </v-card>
      </div>

      <v-textarea
        outlined
        label="対応状況"
        class="mb-3"
        v-model="target.progress"
        rows="6"
        hide-details
      ></v-textarea>

      <v-card class="pa-3" min-height="210">
        <v-file-input
          v-model="currentFile"
          accept=".jpg,.jpeg,.png,.pdf"
          ref="inputFile"
          style="display: none"
          @change="loadFile()"
        />
        <div class="d-flex my-2">
          <div class="caption mr-4">添付ファイル</div>
          <v-btn @click="selectFile()" x-small>ファイルを追加する</v-btn>
        </div>
        <v-card class="d-flex flex-wrap" flat>
          <v-card
            v-for="(row, index) in files"
            :key="index"
            class="mr-2 mt-2 pa-2"
            outlined
          >
            <div style="cursor: pointer" @click="preview(row)">
              <template v-if="isPdf(row)">
                <v-card
                  width="120"
                  height="100"
                  flat
                  class="d-flex justify-center align-center"
                >
                  <v-icon x-large>mdi-file-pdf-box</v-icon>
                </v-card>
              </template>
              <template v-else-if="row.objectUrl">
                <v-img
                  :src="row.objectUrl"
                  width="120"
                  height="100"
                  contain
                  class="d-flex"
                />
              </template>
              <template v-else-if="row.url">
                <v-img
                  :src="row.url"
                  width="120"
                  height="100"
                  contain
                  class="d-flex"
                />
              </template>
            </div>
            <div class="d-flex">
              <v-btn x-small @click="removeFile(index)">
                削除
              </v-btn>
            </div>
          </v-card>
        </v-card>
      </v-card>

      <div class="py-2 d-flex align-center">
        <v-btn color="error" text small @click="remove()" v-if="target.id > 0">
          <v-icon>mdi-delete</v-icon>
          削除
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('close')">
          キャンセル
        </v-btn>
        <v-btn color="primary" @click="save()">
          保存
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from "moment";
import chronologyAPI from "../../utils/chronologyAPI";
const MAX_FILE_SIZE = 1000 * 1000 * 10.5;

export default {
  name: "ChronologyProgress",
  components: {},

  props: {
    dialog: Boolean,
    data: Object,
    maxWidth: {
      type: [String, Number],
      default: 800
    }
  },

  data() {
    return {
      target: {},
      currentFile: undefined,
      files: [],
      currentDate: moment().toISOString()
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  watch: {
    dialog(val) {
      if (!val) return;
      this.load();
    }
  },

  mounted() {
    //
  },

  methods: {
    load() {
      this.currentFile = undefined;
      if (this.data.id === 0) {
        this.target = {
          hash: this.data.hash,
          id: 0,
          chronologyId: this.data.chronologyId,
          date: moment().toISOString(),
          user:
            this.user["custom:department"] +
            " " +
            this.user["custom:user_name"],
          progress: ""
        };
        if (this.data.user) {
          this.target.user = this.data.user;
        }
        this.files = [];
      } else {
        const d = moment.utc(this.data.date, "YYYYMMDDHHmm");
        this.target = { ...this.data, date: d.toISOString() };
        this.files = this.data.files.map(s3Key => {
          return {
            url: `https://hodatsushimizu-chronology.riskma.jp/${s3Key}`,
            s3: s3Key
          };
        });
      }
      if (!this.target.hash || !this.target.chronologyId) {
        this.target = null;
        return;
      }
    },

    isPdf(row) {
      if (!row) return false;
      if (row.file) {
        return row.file.type === "application/pdf";
      } else {
        return row.url.endsWith(".pdf");
      }
    },

    preview(row) {
      if (!row) return;
      if (row.file && row.objectUrl) {
        window.open(row.objectUrl);
      } else if (row.url) {
        window.open(row.url);
      }
    },

    removeFile(index) {
      if (!confirm("削除しますか？") || this.files.length <= index) {
        return;
      }
      if (index < 0) return;
      this.files.splice(index, 1);
    },

    selectFile() {
      const elm = this.$refs.inputFile;
      elm.$children[0].$el.click();
    },

    async loadFile() {
      if (!this.currentFile) return;
      if (this.currentFile.size > MAX_FILE_SIZE) {
        this.currentFile = null;
        alert("ファイルサイズが10MBを超えています");
        return;
      }
      this.files.push({
        file: this.currentFile,
        objectUrl: URL.createObjectURL(this.currentFile)
      });
      this.currentFile = undefined;
    },

    async postChronologyProgress() {
      const params = {
        ...this.target,
        date: Number(moment.utc(this.target.date).format("YYYYMMDDHHmm")),
        userId: this.user.id
      };
      const response = await chronologyAPI.post("progress", params);
      if (response && response.success === true) {
        this.$emit("close");
      }
    },

    async save() {
      if (this.target.progress === "") {
        alert("対応状況を入力してください");
        return;
      }

      // 画像なし
      if (this.files.length === 0) {
        this.target.files = [];
        this.postChronologyProgress();
        return;
      }

      // アップロード済み
      if (this.files.filter(f => f.file).length === 0) {
        this.target.files = this.files.map(f => f.s3);
        this.postChronologyProgress();
        return;
      }

      // アップロード
      this.target.files = [];
      for (let i = 0; i < this.files.length; i++) {
        const row = this.files[i];
        if (row.file) {
          this.target.files.push("");
        } else {
          this.target.files.push(row.s3);
        }
      }
      const processes = this.files.map((row, index) => {
        return (async () => {
          if (row.file) {
            const s3Key = await chronologyAPI.uploadFile(row.file);
            if (s3Key) {
              this.target.files[index] = s3Key;
            }
          }
        })();
      });
      await Promise.all(processes);
      this.target.files = this.target.files.filter(f => f !== "");
      this.postChronologyProgress();
    },

    async remove() {
      if (
        !this.target ||
        !this.target.hash ||
        !this.target.id ||
        !this.target.chronologyId
      ) {
        return;
      }
      if (!confirm("削除しますか？")) return;

      const params = {
        hash: this.target.hash,
        id: this.target.id,
        chronologyId: this.target.chronologyId
      };
      const response = await chronologyAPI.del("progress", params);
      if (response && response.success === true) {
        this.$emit("close");
      }
    }
  }
};
</script>

<style lang="scss">
.chronology-datetime-picker {
  cursor: pointer;
  background-color: white;
  color: black;
  font-size: 12px;
  padding: 0;
  margin: 0;
  height: 22px;
  @media screen and (min-width: 900px) {
    font-size: 16px;
  }
}
.v-textarea textarea {
  font-size: 14px !important;
  line-height: 1.5 !important;
  @media screen and (min-width: 900px) {
    font-size: 16px !important;
  }
}
</style>
